import { render, staticRenderFns } from "./wjCombination.vue?vue&type=template&id=0a8ff682&scoped=true"
import script from "./wjCombination.vue?vue&type=script&lang=js"
export * from "./wjCombination.vue?vue&type=script&lang=js"
import style0 from "./wjCombination.vue?vue&type=style&index=0&id=0a8ff682&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a8ff682",
  null
  
)

export default component.exports